import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Pill } from '@scoir/pills'

const useStyles = makeStyles(() => ({
  messageTitleCell: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 2,
    fontSize: 'inherit',
  },
  cell: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  message: {
    overflow: 'hidden',
  },
}))

type MessageCellProps = {
  data: {
    Subject: string
    Message: string
    IsStarter?: boolean
  }
}

const MessageCell = ({ data }: MessageCellProps) => {
  const classes = useStyles()
  const stripDescription = () => {
    const desc = new DOMParser().parseFromString(data.Message, 'text/html')
    return desc.body.textContent || ''
  }
  return (
    <div className={classes.cell}>
      <div className={classes.message}>
        <Typography className={classes.messageTitleCell}>{data.Subject}</Typography>
        <Typography
          color="textSecondary"
          className={classes.messageTitleCell}
        >
          {stripDescription()}
        </Typography>
      </div>
      {data.IsStarter && <Pill color="info">Starter</Pill>}
    </div>
  )
}
export default MessageCell
